export const datas = [
  {
    id: "94229",
    name: "神厨小福贵",
    channel: "少儿",
    channel_id: "13",
    avatar:
      "http://img1.funshion.com/sdw?oid=b59627802faad45ee4d54f72465aa1db&w=0&h=0",
    poster:
      "http://img2.funshion.com/sdw?oid=7848e2abad56642a70121b6d003182e8&w=0&h=0",
    release: "2008年02月22日",
    product_date: "",
    score: "8.1",
    director: "",
    actor: "",
    scriptwriter: "",
    category: "搞笑,儿童乐园",
    area: "中国内地",
    description: "满汉全席不过小菜一碟",
    content:
      "《神厨小福贵》：清末，八国联军入京，慈禧太后携光绪皇帝等人仓皇西逃。西行路上，由于御膳大厨失踪，慈禧只得命太监小李子在当地挑选厨师。小福贵的爷爷有一手好厨艺，被小李子选为慈禧的御用厨师，但他却无意中发现有人给慈禧的菜肴中下了毒……小福贵的爷爷不幸被认定是下毒凶手，判处秋后问斩。为了救出爷爷，小福贵只有在刑期之前成为首席御厨，才能获得皇帝赐予的免死金牌。身手不凡的神厨小福贵苦练十八般厨艺，就在他成为首席御膳大厨时却又被卷入了一场政治斗争的漩涡中。",
    totalnum: "132",
    update: "全132集",
    isend: "1",
    vv: "17436598",
    status: "1",
    isvip: "0",
    exclusive: "0",
    isfee: "0",
    vod_price: [],
    vod_days: "0",
    update_time: "2023-02-21 14:52:30",
    fun_h5_url:
      "http://m.fun.tv/focplay/?mid=94229&vid=97953&malliance=fe1q8vd",
  },
  {
    id: "324689",
    name: "贝乐虎故事",
    channel: "少儿",
    channel_id: "13",
    avatar:
      "http://img.funshion.com/sdw?oid=4bdca05d1772f452b4484afe16aa8182&w=0&h=0",
    poster:
      "http://img2.funshion.com/sdw?oid=2747482e202e93c9106bb4083fe3fb30&w=0&h=0",
    release: "2016年09月08日",
    product_date: "",
    score: "8.4",
    director: "",
    actor: "",
    scriptwriter: "",
    category: "早教,萌宠,故事,益智启蒙",
    area: "中国内地",
    description: "听故事明事理辨是非 ",
    content:
      "《贝乐虎故事》：贝乐虎故事让小朋友娱乐之余，可以认识社会，引导你做一个通达事理、明辨是非的人。",
    totalnum: "41",
    update: "全41集",
    isend: "1",
    vv: "83",
    status: "1",
    isvip: "0",
    exclusive: "0",
    isfee: "0",
    vod_price: [],
    vod_days: "0",
    update_time: "2023-02-21 14:52:30",
    fun_h5_url:
      "http://m.fun.tv/focplay/?mid=324689&vid=1178745&malliance=fe1q8vd",
  },
  {
    id: "1001789",
    name: "猪猪侠之深海小英雄 第二季",
    channel: "少儿",
    channel_id: "13",
    avatar:
      "http://img1.funshion.com/sdw?oid=2554d7015f3d79e7e68b1bcf2cc60ebf&w=0&h=0",
    poster:
      "http://img.funshion.com/sdw?oid=d2cdc8f7c33691f3c2d6f983fb9acce2&w=0&h=0",
    release: "2020年09月21日",
    product_date: "",
    score: "6.6",
    director: "",
    actor: "",
    scriptwriter: "",
    category: "冒险",
    area: "内地",
    description: "聂墨西斯大王死灰复燃",
    content:
      "《猪猪侠之深海小英雄 第二季》：当年的聂墨西斯大王死灰复燃，给猪猪侠团队制造了各种危险麻烦，但是主角团队并没有因此而退缩，反而迎难而上，在困难中不断成长。逐渐加深的团队默契和保卫家园的信念让他们坚信自己是可以拯救世界的英雄。冒险小队与珊瑚公主等一批正义之士并肩作战，挫败了聂墨西斯一系列阴谋诡计，接下来的任务将更加艰巨，但他们依然勇往直前，永不言弃。",
    totalnum: "26",
    update: "全26集",
    isend: "1",
    vv: "53",
    status: "1",
    isvip: "0",
    exclusive: "0",
    isfee: "0",
    vod_price: [],
    vod_days: "0",
    update_time: "2023-02-21 14:52:10",
    fun_h5_url:
      "http://m.fun.tv/focplay/?mid=1001789&vid=10119115&malliance=fe1q8vd",
  },
  {
    id: "1012227",
    name: "猫小帅儿歌",
    channel: "少儿",
    channel_id: "13",
    avatar:
      "http://img2.funshion.com/sdw?oid=a7039bfccb19b3b8a0486c07ed5bd8c9&w=0&h=0",
    poster:
      "http://img3.funshion.com/sdw?oid=30b95f78050c52404185142761dffe97&w=0&h=0",
    release: "2017年02月09日",
    product_date: "",
    score: "6.8",
    director: "",
    actor: "",
    scriptwriter: "",
    category: "早教",
    area: "内地",
    description: "经典儿歌开启美好一天",
    content:
      "《猫小帅儿歌》：本片包含经典儿歌、动画歌曲、英文歌曲、流行儿歌、睡前儿歌、好习惯儿歌等。原创动画制作精良，画面细腻、动作流畅、色彩明亮，丰富的内容涉及孩子生活、学习及成长的各个方面，推出之后深受爸爸妈妈和宝贝们的喜爱。",
    totalnum: "60",
    update: "全60集",
    isend: "1",
    vv: "34",
    status: "1",
    isvip: "0",
    exclusive: "0",
    isfee: "0",
    vod_price: [],
    vod_days: "0",
    update_time: "2023-02-21 14:52:30",
    fun_h5_url:
      "http://m.fun.tv/focplay/?mid=1012227&vid=10561763&malliance=fe1q8vd",
  },
  {
    id: "1025863",
    name: "小猪佩奇食玩 第二季",
    channel: "少儿",
    channel_id: "13",
    avatar:
      "http://img1.funshion.com/sdw?oid=6561935c2a82d16fd9bf890c00809067&w=0&h=0",
    poster:
      "http://img.funshion.com/sdw?oid=808159f71e08bb137beffa252ef55829&w=0&h=0",
    release: "2022年07月01日",
    product_date: "",
    score: "7.2",
    director: "",
    actor: "",
    scriptwriter: "",
    category: "",
    area: "内地",
    description: "粉红猪小妹的趣味食玩",
    content:
      "《小猪佩奇食玩 第二季》：小猪佩奇带领小伙伴和大家分享好玩有趣的食玩玩具，第2季火热来袭，这次可是全新趣味食玩哦！",
    totalnum: "17",
    update: "全17集",
    isend: "1",
    vv: "93",
    status: "1",
    isvip: "0",
    exclusive: "0",
    isfee: "0",
    vod_price: [],
    vod_days: "0",
    update_time: "2023-02-21 14:52:30",
    fun_h5_url:
      "http://m.fun.tv/focplay/?mid=1025863&vid=11139671&malliance=fe1q8vd",
  },
];
